import { GlobalServicesLoginDetails } from '@maximizer/core/shared/domain';
import { OnPremLoginDetails } from '@maximizer/core/shared/data-access';

export enum RegionalSubdomain {
  UK = 'uk',
  EMEA = 'emea',
}

export interface BrowserOnlyAccessTokenHydration {
  accessToken: string;
  tokenType?: string;
  expiresIn?: number;
  expiresAt?: Date | string;
  isCloud: boolean;
  cloudLoginDetails?: GlobalServicesLoginDetails;
  onPremLoginDetails?: OnPremLoginDetails;
  mxUserId?: string;
  mxUserEmail?: string;
}

export interface StoredUserCredentials {
  userId: string;
  userEmail: string;
  partitionKey: string;
  lastLogin: number;
}

export interface StoredLoginDetails {
  isCloud: boolean;
  cloudDetails?: GlobalServicesLoginDetails;
  onPremDetails?: OnPremLoginDetails;
}

export interface SecureStoragePayload<T> {
  version: string;
  timestamp: number;
  data: T;
  checksum: string;
}
